/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsCurrency
 */
export interface MelcoModelsCurrency {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsCurrency
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsCurrency
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsCurrency
     */
    symbol?: string | null;
}

export function MelcoModelsCurrencyFromJSON(json: any): MelcoModelsCurrency {
    return MelcoModelsCurrencyFromJSONTyped(json, false);
}

export function MelcoModelsCurrencyFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsCurrency {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'symbol': !exists(json, 'symbol') ? undefined : json['symbol'],
    };
}

export function MelcoModelsCurrencyToJSON(value?: MelcoModelsCurrency | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'name': value.name,
        'symbol': value.symbol,
    };
}


